module.exports = __webpack_public_path__ + "static/pic04-5a8d4c7bd7d890ee2ead7e94dafa7e26.jpg";